import PropTypes from 'prop-types';

import { Spinner } from '@utilities';
import { TrashIcon } from '@utilities/icons';

import { formatTimestamp } from '../../../../utilities/helpers';

import styles from './_index.module.scss';

const Bookmark = ({
  bookmarks = [],
  isLoadingBookmarks = false,
  onDeleteBookmark,
  onSeekToTimestamp,
}) => {
  const handleBookmarkClick = (bookmark) => {
    if (onSeekToTimestamp && bookmark.start_ts !== null && bookmark.start_ts !== undefined) {
      onSeekToTimestamp(bookmark.start_ts, bookmark.end_ts);
    }
  };

  const handleDeleteClick = (event, bookmarkId) => {
    event.stopPropagation();
    if (onDeleteBookmark) {
      onDeleteBookmark(bookmarkId);
    }
  };

  const sortedBookmarks = [...bookmarks].sort((a, b) => (a.start_ts || 0) - (b.start_ts || 0));

  return (
    <div className={styles['bookmark']} data-testid="video-bookmarks-container">
      <h3>Bookmarks</h3>
      <div className={styles['bookmark-content']}>
        {isLoadingBookmarks ? (
          <Spinner />
        ) : sortedBookmarks.length > 0 ? (
          sortedBookmarks.map((bookmark) => {
            return (
              <div
                className={styles['bookmark-item-wrapper']}
                data-testid="bookmark-item-wrapper"
                key={bookmark.id}
              >
                <button
                  className={styles['bookmark-item']}
                  data-testid="bookmark-item"
                  onClick={() => handleBookmarkClick(bookmark)}
                  type="button"
                >
                  {bookmark.start_ts !== null && bookmark.start_ts !== undefined && (
                    <span className={styles['bookmark-timestamp']}>
                      {formatTimestamp(bookmark.start_ts)}
                    </span>
                  )}
                  <span className={styles['bookmark-text']}>{bookmark.text}</span>
                </button>
                {onDeleteBookmark && (
                  <button
                    className={styles['bookmark-delete-button']}
                    data-testid="bookmark-delete-button"
                    onClick={(e) => handleDeleteClick(e, bookmark.id)}
                    title="Delete bookmark"
                    type="button"
                  >
                    <TrashIcon />
                  </button>
                )}
              </div>
            );
          })
        ) : (
          <p className={styles['bookmark-no-content']} data-testid="bookmark-empty-message">
            No bookmarks added yet
          </p>
        )}
      </div>
    </div>
  );
};

Bookmark.propTypes = {
  bookmarks: PropTypes.arrayOf(
    PropTypes.shape({
      end_ts: PropTypes.number,
      id: PropTypes.number,
      item_indices: PropTypes.arrayOf(PropTypes.number),
      start_ts: PropTypes.number,
      text: PropTypes.string,
    })
  ),
  isLoadingBookmarks: PropTypes.bool,
  onDeleteBookmark: PropTypes.func,
  onSeekToTimestamp: PropTypes.func,
};

export default Bookmark;
